/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css } from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from '../../../theme';
import { Heading4 } from '../../shared/Typography';

export const StyledWhenInfographic = styled.div`
  margin-top: ${spacing('xl')};
  @media (min-width: ${screen('md')}) {
    display: none;
  }
`;

export const StyledWhenInfographicTitle = styled(Heading4)`
  margin-bottom: ${spacing('sm')};
`;

export const StyledWhenInfographicBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${spacing('xs2')};
  margin-bottom: ${spacing('sm')};
`;

const variants: {
  [key: string]: {
    color?: ((props: any) => any) | string;
    backgroundColor?: ((props: any) => any) | string;
    colorSeparator?: ((props: any) => any) | string;
    colorLabel?: ((props: any) => any) | string;
    paddingV?: ((props: any) => any) | string;
  };
} = {
  flexible: {
    color: color('emerald_700'),
    backgroundColor: color('emerald_150'),
    colorSeparator: color('emerald_500'),
    colorLabel: color('emerald_500'),
    paddingV: spacing('xs')
  },
  free: {
    color: color('emerald_700'),
    backgroundColor: color('white'),
    colorSeparator: color('emerald_500'),
    colorLabel: color('emerald_500'),
    paddingV: spacing('xs')
  }
};

export const StyledWhenInfographicItemLabel = styled.span`
  display: block;
  text-align: center;
  font-family: ${fontFamily('sans')};
  text-transform: uppercase;
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('sm')};
  color: ${color('text_subtle')};
  margin-bottom: ${spacing('xs2')};
`;

export const StyledWhenInfographicItemValue = styled.span`
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl4')};
  font-weight: ${fontWeight('light')};
  line-height: 1;
  .separator {
    color: ${color('text_placeholder')};
  }
`;

export const StyledWhenInfographicItemExtra = styled.span`
  font-size: ${fontSize('xs')};
  font-weight: ${fontWeight('extraBold')};
  color: ${color('text_subtle')};
  display: block;
`;

export const StyledWhenInfographicItem = styled.div<{
  schedule?: string;
}>`
  padding: ${spacing('xs2')} ${spacing('sm')};
  border-radius: ${radius('md')};

  ${({ schedule }) =>
    schedule &&
    variants[schedule] &&
    css`
      color: ${variants[schedule].color};
      background-color: ${variants[schedule].backgroundColor};
      padding: ${variants[schedule].paddingV} ${spacing('sm')};
      .separator {
        color: ${variants[schedule].colorSeparator};
      }
      ${StyledWhenInfographicItemLabel} {
        color: ${variants[schedule].colorLabel};
      }
      ${StyledWhenInfographicItemExtra} {
        color: ${variants[schedule].colorLabel};
      }
    `}
`;
